module.exports = __webpack_public_path__ + "static/media/iconclose.631840cd.svg";